module.exports = __webpack_public_path__ + "img/activity-banner.5d8cdff5.png";